import {
    GET_CONTACT_PHONE_REPORT,
    GET_CONTACT_PHONE_REPORT_ERROR,
    CLEAN_GET_CONTACT_PHONE_REPORT,
    CLEAN_GET_CONTACT_PHONE_REPORT_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CONTACT_PHONE_REPORT:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case GET_CONTACT_PHONE_REPORT_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_GET_CONTACT_PHONE_REPORT:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_GET_CONTACT_PHONE_REPORT_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
